import { HourglassTopRounded, SavingsRounded, TaskAltRounded } from "@mui/icons-material";
import { Box, Card, CardContent, Divider, Typography } from "@mui/joy";
import moment from "moment";

import { TopCards, PriorityTasks, Assistance, ManageProject, Analytics } from "./components";

import { useAuth } from "../../hooks";

export default function Dashboard() {
    const { user } = useAuth();
    return (
        <Box
            m={0}
            mb={0}
            ml={3}
            mt={1}
            mr={0}
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            overflow={"auto"}
            position={"relative"}
        >
            <Box mt={1}>
                <Typography level="h3" component={"span"}>
                    {greeting}! {user?.FirstName ? user?.FirstName : user?.Email},
                    <Typography gutterBottom level="body-sm" sx={{ fontWeight: 400 }}>
                        &nbsp;{moment().format("dddd, Do MMMM")}
                    </Typography>
                </Typography>
            </Box>
            <Box
                display={"flex"}
                gap={0}
                width={"100%"}
                justifyContent={"space-between"}
                flex={1}
                flexShrink={0}
                pr={2}
            >
                <Box flex={1} pr={1}>
                    <TopCards />
                    <Analytics />
                    <ManageProject />
                </Box>
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    gap={2}
                    mb={2}
                    flexShrink={0}
                    width={350}
                    pl={1}
                    position={"sticky"}
                    top={40}
                    maxHeight={"calc(100vh - 130px)"}
                >
                    <PriorityTasks />
                    <Assistance />
                </Box>
            </Box>
        </Box>
    );
}

const greeting = (() => {
    const h = moment().hour();
    return h < 5
        ? "Good Night"
        : h < 12
        ? "Good Morning"
        : h < 17
        ? "Good Afternoon"
        : h < 21
        ? "Good Evening"
        : "Good Night";
})();
